import Crud from '../components/Vehicle/Crud'
import Entity from '../components/Vehicle/Add'
import View from '../components/Vehicle/View'

let routes = {
    path: '/vehicle',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/vehicles/add',
            name: 'Novo Veículo',
            component: Entity
        },
        {
            path: '/vehicles/edit/:id?',
            name: 'Editar Veículo',
            component: Entity
        },
        {
            path: '/vehicles',
            name: 'Veículos',
            component: Crud
        },
        {
            path: '/vehicles/view/:id?',
            name: 'Visualização de Veículo',
            component: View
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/vehicle.js